<template>
    <div>
        <div class="div-block-4"></div>
        <div data-collapse="medium" data-animation="default" data-duration="400" class="header-navigation fixed w-nav">
            <NetworkStatus/>
            <HeaderMenu/>
        </div>

        <div class="section section-color center">
            <div class="w-container" style="padding:40px 0 0 0">
                <h1 class="key-number">{{ $t('blog') }}</h1>
            </div>
        </div>

        <div class="page-content">
            <div class="inline top-spacer-40">
                <img src="images/coffee_shop_interior.png" class="blog-image" alt="AI-Powered Local Advertising" v-on:click="redirect('blog_how_small_businesses_can_compete.html')"/>
                <div>
                    <a href="blog_how_small_businesses_can_compete.html" class="blog-link">May 12, 2025 – <b>AI-Powered Local Advertising: How Small Businesses Can Compete with Big Brands</b></a>
                    <p>For many small business owners, competing with large national brands can feel like a losing game. Big companies have entire marketing teams, massive ad budgets, and endless data at their disposal. But here&rsquo;s the good news: you don&rsquo;t need all of that to win in your local market.
                        <a href="blog_how_small_businesses_can_compete.html">Read Now</a></p>
                </div>
            </div>

            <div class="inline top-spacer-40">
                <img src="images/insurance_agency_building.png" class="blog-image" alt="How to Get Leads for Life Insurance" v-on:click="redirect('blog_how_to_get_leads_for_life_insurance.html')"/>
                <div>
                    <a href="blog_how_to_get_leads_for_life_insurance.html" class="blog-link">April 1, 2025 – <b>How to Get Leads for Life Insurance: Best Strategies for 2025</b></a>
                    <p>When it comes to growing a life insurance business, not all leads are created equal. Buying cold leads or advertising nationally may get you volume&mdash;but local leads are where the real opportunity lies.
                        <a href="blog_how_to_get_leads_for_life_insurance.html">Read Now</a></p>
                </div>
            </div>

            <div class="inline top-spacer-40">
                <img src="images/restaurant_outdoor_seating.png" class="blog-image" alt="Marketing Ideas for Local Restaurants and Cafes" v-on:click="redirect('blog_marketing_ideas_for_local_restaurants.html')"/>
                <div>
                    <a href="blog_marketing_ideas_for_local_restaurants.html" class="blog-link">January 8, 2025 – <b>Marketing Ideas for Local Restaurants and Cafes: How to Attract and Retain Customers</b></a>
                    <p>Running a local restaurant or cafe is both exciting and competitive. With so many dining options available, standing out in your neighborhood is essential. From the aroma of fresh-brewed coffee to a well-curated menu, your business has the potential to thrive&mdash;if customers can find you.
                        <a href="blog_marketing_ideas_for_local_restaurants.html">Read Now</a></p>
                </div>
            </div>

            <div class="inline top-spacer-60">
                <img src="images/street_decorated_for_christmas.png" class="blog-image" alt="Holiday Shoppers" v-on:click="redirect('blog_holiday_shoppers.html')"/>
                <div>
                    <a href="blog_holiday_shoppers.html" class="blog-link">December 2, 2024 – <b>How Small Businesses Can Attract Holiday Shoppers</b></a>
                    <p>The holiday season is one of the biggest sales opportunities for small businesses. In fact, holiday sales can account for up to 20% of annual retail sales for some businesses, with Americans spending over $800 billion during the holiday months alone (National Retail Federation). During the holidays, people are eager to support local businesses. It’s a prime time for small businesses to boost their visibility, attract new customers, and increase sales.
                    <a href="blog_holiday_shoppers.html">Read Now</a></p>
                </div>
            </div>

            <div class="inline top-spacer-40">
                <img src="images/main_street_store.png" class="blog-image" alt="Advertising Strategies" v-on:click="redirect('blog_advertising_strategies.html')"/>
                <div>
                    <a href="blog_advertising_strategies.html" class="blog-link">November 15, 2024 – <b>The Best Local Advertising Strategies for Small Businesses</b></a>
                    <p>In today&rsquo;s competitive landscape, local advertising is vital for small businesses wanting to stand out and attract customers from their communities. From search engine optimization to online reviews, there are numerous ways to enhance your local presence. Here, we&rsquo;ll explore the best local advertising strategies for small businesses, including top tips for boosting local visibility and why LocalScale can be your most cost-effective advertising solution.
                    <a href="blog_advertising_strategies.html">Read Now</a></p>
                </div>
            </div>
        </div>

        <Footer/>
    </div>
</template>

<style>
.page-content {
    margin-left: auto;
    margin-right: auto;
    max-width: 1225px;
    padding-bottom: 40px;
    padding-left: 1em;
    padding-right: 1em;
}
.header-text p {
    font-size: 18px;
    color: #363636;
}
.blog-image {
    height:200px;
    margin-top: 10px;
    margin-right: 30px;
    cursor: pointer;
}
.blog-link {
    color: #363636;
    text-decoration: none;
    cursor: pointer;
}
.inline {
    display: inline-flex;
}
.top-spacer-40 {
    margin-top: 40px;
}
.top-spacer-60 {
    margin-top: 60px;
}
@media (max-width: 991px) {
    .section .w-container .key-number {
        padding: 80px 0 10px 0;
    }
}
@media (max-width: 479px) {
    .page-content {
        margin: 0 20px 0 20px;
        width: 350px;
    }
}
</style>

<script>
import HeaderMenu from "../components/HeaderMenu";
import NetworkStatus from "../components/NetworkStatus.vue";
import Footer from "../components/Footer";
import session from '../session'

export default {
    components: {
        HeaderMenu, NetworkStatus, Footer
    },
    methods: {
        redirect: function (url) {
            session.navigateToPage(url);
        }
    }
}
</script>
